import { useEffect, useRef, useState } from "react";
import { Translate } from "../ChoosePlanCarePlus/planContent";

// faq_q1 ("Was ist Care+?") is not shown on V3.
const FAQ_NUMBERS = [2, 3, 4] as const;

interface CarePlusShippingFAQProps {
  t: Translate;
}

const CarePlusShippingFAQ = ({ t }: CarePlusShippingFAQProps) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const itemRefs = useRef<Array<HTMLDivElement | null>>([]);

  // Last answer sits under sticky confirm chrome; bring the open item into view.
  useEffect(() => {
    if (openIndex == null) return;
    const node = itemRefs.current[openIndex];
    if (!node) return;
    // rAF so the answer is in the layout before measuring scroll.
    const id = requestAnimationFrame(() => {
      node.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
    });
    return () => cancelAnimationFrame(id);
  }, [openIndex]);

  return (
    <div className="flex w-full flex-col">
      {FAQ_NUMBERS.map((n, i) => {
        const qKey = `faq_q${n}`;
        const aKey = `faq_a${n}`;
        const isOpen = openIndex === i;
        return (
          <div
            key={qKey}
            ref={(el) => {
              itemRefs.current[i] = el;
            }}
            className="flex w-full flex-col"
          >
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : i)}
              className="flex h-[60px] w-full cursor-pointer items-center justify-between border-none bg-transparent p-0 py-[6px] text-left transition-colors hover:text-[#e17200] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#e17200]"
              aria-expanded={isOpen}
            >
              <span className="min-w-0 flex-1 pr-[12px] text-[16px] text-[#4d4d4d]">{t(qKey, "")}</span>
              <span className="flex size-[24px] shrink-0 items-center justify-center rounded-full text-[17px] font-medium">
                <span
                  className="bg-clip-text text-transparent"
                  style={{ backgroundImage: "linear-gradient(222.69deg, #ffb909 0.8%, #e17200 94.83%)" }}
                >
                  {isOpen ? "−" : "+"}
                </span>
              </span>
            </button>
            {isOpen && t(aKey, "") && (
              <p className="w-full pb-[16px] text-[13px] text-[#656d79]">{t(aKey, "")}</p>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CarePlusShippingFAQ;
